"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import useIsClient from "@/hooks/useIsClient";
import useShouldFire from "./useShouldFire";
export default function useFacebookPixel(
  pixel_id?: string | number,
  refresh?: boolean,
  advancedMatching?: any,
) {
  const pathname = usePathname();
  const client = useIsClient();
  const shouldFire = useShouldFire();
  useEffect(() => {
    if (!pixel_id || !client || !shouldFire) return;
    if (pathname) {
      let ReactPixel: any;
      import("react-facebook-pixel")
        .then((module) => (ReactPixel = module.default))
        .then(() => {
          const initAdvancedMatching: any = {};
          if (advancedMatching) {
            console.log({ advancedMatching });
            if (advancedMatching.email)
              initAdvancedMatching.em = advancedMatching.email;
            if (advancedMatching.email_hash)
              initAdvancedMatching.em = advancedMatching.email_hash;
            if (advancedMatching.phone)
              initAdvancedMatching.ph = advancedMatching.phone;
            if (advancedMatching.phone_hash)
              initAdvancedMatching.ph = advancedMatching.phone_hash;
            if (advancedMatching.external_id)
              initAdvancedMatching.external_id = advancedMatching.external_id;
            if (advancedMatching.fbc)
              initAdvancedMatching.fbc = advancedMatching.fbc;
            if (advancedMatching.fbp)
              initAdvancedMatching.fbp = advancedMatching.fbp;
            if (advancedMatching.first_name)
              initAdvancedMatching.fn = advancedMatching.first_name;
            if (advancedMatching.last_name)
              initAdvancedMatching.ln = advancedMatching.last_name;
            if (advancedMatching.city_name)
              initAdvancedMatching.ct = advancedMatching.city_name;
          }

          ReactPixel.init(pixel_id, initAdvancedMatching, {
            autoConfig: true,
          });
          ReactPixel.pageView();
        });
    }
  }, [pathname, client, pixel_id, refresh, shouldFire, advancedMatching]);
  function trackEvent(event: any, data: any, eventID?: string) {
    console.log({ event, data, eventID });
    let ReactPixel: any;
    import("react-facebook-pixel")
      .then((module) => (ReactPixel = module.default))
      .then(() => {
        const customerInfo: any = {};

        if (data.email) customerInfo.em = data.email;
        if (data.email_hash) customerInfo.em = data.email_hash;
        if (data.phone) customerInfo.ph = data.phone;
        if (data.phone_hash) customerInfo.ph = data.phone_hash;
        if (data.external_id) customerInfo.external_id = data.external_id;
        if (data.client_ip_address)
          customerInfo.client_ip_address = data.client_ip_address;
        if (data.client_user_agent)
          customerInfo.client_user_agent = data.client_user_agent;
        if (data.fbc) customerInfo.fbc = data.fbc;
        if (data.fbp) customerInfo.fbp = data.fbp;
        if (data.first_name) customerInfo.first_name = data.first_name;
        if (data.last_name) customerInfo.last_name = data.last_name;

        const eventData = { ...data };
        delete eventData.email;
        delete eventData.email_hash;
        delete eventData.phone;
        delete eventData.phone_hash;
        delete eventData.external_id;
        delete eventData.client_ip_address;
        delete eventData.client_user_agent;
        delete eventData.fbc;
        delete eventData.fbp;
        delete eventData.first_name;
        delete eventData.last_name;

        console.log(
          JSON.stringify({
            event,
            eventData,
            extra: { eventID: eventID || undefined, ...customerInfo },
          }),
        );
        ReactPixel.track(event, eventData, {
          eventID: eventID || undefined,
          ...customerInfo,
        });
      })
      .then(() => {
        if ((event as string).toLocaleLowerCase() === "purchase")
          fetch("/api/log-info", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              message: "facebook pixle Purchase event",
              details: {
                ...data,
              },
              host:
                typeof window !== "undefined"
                  ? window.location.hostname
                  : "server",
              url:
                typeof window !== "undefined" ? window.location.pathname : "",
            }),
          });
      });
  }

  return { trackEvent };
}
